export default __webpack_public_path__ + "static/media/intro.c8c172c3.png";